import {useEffect} from 'react';
import {useGetCoupons} from './CouponWallet/hooks/useGetCoupons';
import {useActivatedCouponState} from './useActivatedCouponState';
import {useEntryUrlCrmCouponTokenParam} from './useCrmCouponTokenParam';

/**
 * Clean active coupon from useActivatedCouponState when coupon is not in coupon array.
 * We cannot really use responses on ADP to manage that and had to move it into seperate component.
 * This way even if section is not returned we can still see and update values
 */
export const CleanActiveCoupon = ({productId}: {productId: number}) => {
  const coupons = useGetCoupons().data;
  const {couponPromotionId, setActivatedCoupon} =
    useActivatedCouponState(productId);

  const crmCouponToken = useEntryUrlCrmCouponTokenParam();

  useEffect(() => {
    // if a coupon is currently being unlocked, do nothing
    if (crmCouponToken) {
      return;
    }

    if (!coupons) {
      return;
    }

    const foundCoupon = coupons.coupon.find(
      coupon => coupon.type?.active.couponPromotionId === couponPromotionId,
    );
    if (!foundCoupon) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setActivatedCoupon(undefined);
    }
  }, [coupons, couponPromotionId, setActivatedCoupon, crmCouponToken]);

  return null;
};
